import React from 'react';

import SelectField from '../../../../components/inputs/selectField';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import ToggleField from '../../../../components/inputs/toggleField';
import API from '../../../../utils/API';
import TimeField from '../../../../components/inputs/timeField';

class CreateRegistrationFlowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            startOffsetDays: '',
            endOffsetDays: '',
            startTime: '',
            endTime: '',
            openToPublic: false,
            ticketingEnabled: false,
            pageTemplateId: '',
            registrationGroupName: '',
            defaultGroupNames: [
                ...props.groups.map((group) => {
                    return { value: group._id, label: group.name, color: '#00B8D9' };
                })
            ],
            groupNames: [
                ...props.groups.map((group) => {
                    return { value: group._id, label: group.name, color: '#00B8D9' };
                })
            ],
            selectedValue: { label: '', color: '#00B8D9' },
            added: 0,
            submitting: false,
            invalid: false,
            success: false,
            newGroupChosen: false,
            requiredFields: {
                name: false,
                startOffsetDays: false,
                endOffsetDays: false,
                startTime: false,
                endTime: false,
                pageTemplateId: false,
                selectedValue: false
            },
            pageTemplates: []

        };
    }

    async componentDidMount() {
        //get page templates
        const { orgId } = this.props;
        await API().get(`Organizations/${orgId}/getTemplates?templateType=registration`).then((res) => {
            let platformTemplates = [];
            if (res.data) {
                platformTemplates = res.data.map((template) => {
                    return {
                        value: template._id,
                        label: template.title,
                        color: '#00B8D9'
                    };
                });
            }
            this.setState({ pageTemplates: platformTemplates });
        });
    }

    handleNameChange = (e) => {
        const newGroup = {
            label: 'New group: ' + e,
            color: '#00B8D9',
            new: true
        };
        const filteredGRoupNames = this.state.defaultGroupNames.filter((group) => group.label.toLowerCase().includes(e.toLowerCase()));
        this.setState({
            groupNames: [...filteredGRoupNames, newGroup]
        });
    };

    handleGroupChosen = (e) => {
        if (e.new) {
            this.setState({ selectedValue: { ...e, label: e.label.split('New group: ')[1] }, newGroupChosen: true });
        } else {
            this.setState({ selectedValue: e, newGroupChosen: false });
        }
    };

    submit = () => {
        const { orgId, programId } = this.props;
        const { name, startOffsetDays, endOffsetDays, startTime, endTime, ticketingEnabled, pageTemplateId, selectedValue, newGroupChosen, openToPublic } = this.state;

        const requiredFields = {
            name: !name,
            startOffsetDays: !startOffsetDays,
            endOffsetDays: !endOffsetDays,
            startTime: !startTime,
            endTime: !endTime,
            pageTemplateId: !pageTemplateId,
            selectedValue: !selectedValue.label
        };

        this.setState({ requiredFields });
        if (Object.values(requiredFields).some((field) => field)) {
            this.setState({ invalid: true });
            return;
        }

        this.setState({ submitting: true, invalid: false });

        const payload = {
            name: name,
            startOffsetDays: startOffsetDays,
            endOffsetDays: endOffsetDays,
            startTime: startTime,
            endTime: endTime,
            openToPublic: openToPublic,
            ticketingEnabled: ticketingEnabled,
            pageTemplateId: pageTemplateId.value,
        };

        // Handle group assignment (only set once)
        if (newGroupChosen) {
            payload.registrationGroupName = selectedValue.label;
        } else {
            payload.registrationGroup = selectedValue.value;
        }

        // Call updateFlows with success and error callbacks
        this.props.updateFlows(payload,
            // Success callback
            (newFlow) => {
                this.setState({ success: true, submitting: false });
                // Call onSuccess prop if provided
                this.props.onSuccess && this.props.onSuccess(newFlow);
            },
            // Error callback
            (error) => {
                this.setState({ submitting: false, invalid: true });
                this.props.onError && this.props.onError(error);
            }
        );
    };

    render() {
        const { isOpen } = this.props;
        const { groupNames, submitting, success, selectedValue, requiredFields, name,
            startOffsetDays, endOffsetDays, startTime, endTime, ticketingEnabled, pageTemplateId } = this.state;

        return (
            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Add Registration Flow"}
                    bodyHeaderText="Create a registration page for a dedicated attendee type."
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Flow Name"
                                    classes={'w-100'}
                                    value={name}
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.name}
                                    name="name"
                                    type="text"
                                    placeholder="Enter flow name"
                                />
                                <div className='flex gap10'>
                                    <InputField
                                        label="Days before event start"
                                        classes={'w-100'}
                                        value={startOffsetDays}
                                        type="number"
                                        onChange={(e) => this.setState({ startOffsetDays: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.startOffsetDays}
                                        min="0"
                                        placeholder="Enter number of days"
                                    />
                                    <TimeField
                                        label="Start Time"
                                        classes={'w-100'}
                                        value={startTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ startTime: e })}
                                        errorTrigger={requiredFields.startTime}
                                        name="startTime"
                                        placeholder="Enter start time" />
                                </div>
                                <div className='flex gap10'>
                                    <InputField
                                        label="Days after event start"
                                        classes={'w-100'}
                                        value={endOffsetDays}
                                        type="number"
                                        onChange={(e) => this.setState({ endOffsetDays: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.endOffsetDays}
                                        min="0"
                                        name="endOffSetDates"
                                        placeholder="Days after event start"
                                    />
                                    <TimeField
                                        label="End Time"
                                        classes={'w-100'}
                                        value={endTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ endTime: e })}
                                        errorTrigger={requiredFields.endTime}
                                        name="endTime"
                                        placeholder="Enter end time" />
                                </div>
                                <ToggleField
                                    label="Open to Public"
                                    classes={'w-100'}
                                    checked={this.state.openToPublic}
                                    icons={false}
                                    information="Enable this if you want to make this flow available to the public."
                                    onChange={(e) => this.setState({ openToPublic: e.target.checked })}
                                />
                                <SelectField
                                    label="Registration Page Layout"
                                    classes={'w-100'}
                                    value={pageTemplateId}
                                    errorTrigger={requiredFields.pageTemplateId}
                                    name="pageTemplateId"
                                    information="Select a page template for this flow."
                                    options={this.state.pageTemplates}
                                    required
                                    onChange={(e) => this.setState({ pageTemplateId: e })}
                                />

                                <SelectField
                                    label="Registration Group"
                                    classes={'w-100'}
                                    value={selectedValue}
                                    errorTrigger={requiredFields.selectedValue}
                                    name="groupName"
                                    information="Select or create a group attendees that will be added to when they register in this flow."
                                    options={groupNames}
                                    required
                                    onChange={this.handleGroupChosen}
                                    onInputChange={this.handleNameChange}
                                />

                                <ToggleField
                                    label="Enable Ticketing"
                                    classes={'w-100'}
                                    checked={ticketingEnabled}
                                    icons={false}
                                    information="Enable ticketing if you wish to sell tickets for this flow."
                                    onChange={(e) => this.setState({ ticketingEnabled: e.target.checked })}
                                />

                            </div>

                        )
                    }}
                    toggle={this.props.toggle}
                    actionButtonLabel={!success ? !submitting ? 'Submit' : 'Creating...' : ''}
                    cancelButtonLabel={success && 'Close'}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}

                ></FieldModal>
            </div>
        )

    }
}

export default CreateRegistrationFlowModal;
